'use strict';

var _ = require('lodash');
var ValidationSummaryController = function ValidationSummaryController($scope) {
  $scope.msg = $scope.msg || 'There are validation errors';
  $scope.isMessageAnArray = function () {
    return _.isArray($scope.msg);
  };
};
ValidationSummaryController.$inject = ['$scope'];
module.exports = ValidationSummaryController;